// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".download-table a{color:#111418}.download-table a .bp4-icon{color:#5f6b7c}", ""]);
// Exports
module.exports = exports;
